module.exports = __webpack_public_path__ + "static/battery-2cdac68affc8c601218db5f0fe6a9971.svg";